<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <section class="has-text-centered pdb-40px">
        <p class="is-size-3 has-text-weight-bold">
          {{ sens === sensVente ? $t('addDomiciliationBancaire.parametrageLibelle.vente.title')
          : $t('addDomiciliationBancaire.parametrageLibelle.achat.title')}}
        </p>
      </section>
      <b-field
        :label="label">
        <b-input v-model="libelle" ref="libelleInput"/>
      </b-field>
      <div class="columns is-multiline mgb-20px" v-if="isReference">
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="addText('{NUMERO_FACTURE}')">
            {NUMERO_FACTURE}
          </p>
          <p class="has-text-default">
            {{ $t('addDomiciliationBancaire.parametrageLibelle.paramEcriture.numeroFacture') }}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="addText('{REFERENCE_TIRE}')">
            {REFERENCE_TIRE}
          </p>
          <p class="has-text-default">
            {{ $t('addDomiciliationBancaire.parametrageLibelle.paramEcriture.referenceTire') }}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="addText('{REFERENCE_ECRITURE}')">
            {REFERENCE_ECRITURE}
          </p>
          <p class="has-text-default">
            {{ $t('addDomiciliationBancaire.parametrageLibelle.paramEcriture.referenceEcriture') }}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="addText('{VIDE}')">
            {VIDE}
          </p>
          <p class="has-text-default">
            {{ $t('addDomiciliationBancaire.parametrageLibelle.paramEcriture.vide') }}
          </p>
        </div>
      </div>
      <div class="columns is-multiline mgb-20px" v-else>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
              @click="addText('{TYPE_PIECE}')">
            {TYPE_PIECE}
          </p>
          <p class="has-text-default">
            {{$t('addDomiciliationBancaire.parametrageLibelle.paramEcriture.piece')}}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
              @click="addText('{TIERS_COMPTABLE_NOM}')">
            {TIERS_COMPTABLE_NOM}
          </p>
          <p class="has-text-default">
            {{$t('addDomiciliationBancaire.parametrageLibelle.paramEcriture.nom')}}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
              @click="addText('{REFERENCE}')">
            {REFERENCE}
          </p>
          <p class="has-text-default">
            {{$t('addDomiciliationBancaire.parametrageLibelle.paramEcriture.reference')}}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
              @click="addText('{TIERS_COMPTABLE_JURIDIQUE}')">
            {TIERS_COMPTABLE_JURIDIQUE}
          </p>
          <p class="has-text-default">
            {{$t('addDomiciliationBancaire.parametrageLibelle.paramEcriture.nomJuridique')}}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
              @click="addText('{NUMERO_REGLEMENT}')">
            {NUMERO_REGLEMENT}
          </p>
          <p class="has-text-default">
            {{$t('addDomiciliationBancaire.parametrageLibelle.paramEcriture.numero')}}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="addText('{MODE_REGLEMENT}')">
            {MODE_REGLEMENT}
          </p>
          <p class="has-text-default">
            {{$t('addDomiciliationBancaire.parametrageLibelle.paramEcriture.modeReglement')}}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="addText('{NUMEROS_FACTURES}')">
            {NUMEROS_FACTURES}
          </p>
          <p class="has-text-default">
            {{$t('addDomiciliationBancaire.parametrageLibelle.paramEcriture.numerosFactures')}}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="addText('{COMPTEUR_LIGNE}')">
            {COMPTEUR_LIGNE}
          </p>
          <p class="has-text-default">
            {{$t('addDomiciliationBancaire.parametrageLibelle.paramEcriture.compteurLigne')}}
          </p>
        </div>
        <div class="column is-6" v-if="sens === sensVente">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="addText('{ANNONCEURS}')">
            {ANNONCEURS}
          </p>
          <p class="has-text-default">
            {{ $t('addDomiciliationBancaire.parametrageLibelle.paramEcriture.annonceurs') }}
          </p>
        </div>
        <div class="column is-6" v-if="sens === sensVente">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="addText('{NATURE_REGLEMENT}')">
            {NATURE_REGLEMENT}
          </p>
          <p class="has-text-default">
            {{ $t('addDomiciliationBancaire.parametrageLibelle.paramEcriture.nature') }}
          </p>
        </div>
      </div>
      <div class="buttons">
        <qd-button type="is-light"
                  class="btn-modal-annuler"
                  @click="$parent.close()">
          {{$t('addDomiciliationBancaire.parametrageLibelle.paramEcriture.exit')}}
        </qd-button>
        <qd-button type="is-info"
                  @click="save()">
          {{$t('general.button.sauvegarder')}}
        </qd-button>
      </div>
    </div>
  </div>
</template>

<script>
import { SENS_VENTE } from '@/configuration/devisConf';

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    sens: {
      type: String,
      required: true,
    },
    isReference: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    libelle: '',
    sensVente: SENS_VENTE,
  }),
  computed: {
    label() {
      return this.$t('addDomiciliationBancaire.parametrageLibelle.' + this.sens + '.' + this.type);
    },
  },
  methods: {
    addText(text) {
      this.libelle += text;
    },
    save() {
      this.$emit('save', {
        value: this.libelle,
        type: this.type,
      });
      this.$parent.close();
    },
  },
  mounted() {
    this.$refs.libelleInput.focus();
    this.libelle = this.value ? this.value : '';
  },
};
</script>

<style>

</style>
